import React from 'react';

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error, info);
  }

  handleReload = () => {
    // Wis mogelijk corrupte storage om een herhalende crash te voorkomen
    try { localStorage.removeItem('user'); } catch (e) { /* ignore */ }
    try { localStorage.removeItem('token'); } catch (e) { /* ignore */ }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', background: '#121212', color: '#fff', fontFamily: '-apple-system, sans-serif',
          padding: '20px', boxSizing: 'border-box', textAlign: 'center'
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ margin: '0 0 12px', fontSize: '1.2rem' }}>Er ging iets mis</h2>
          <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '24px' }}>
            {this.state.error?.message || 'Onbekende fout'}
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: '#4CAF50', color: '#fff', border: 'none',
              borderRadius: '8px', padding: '12px 28px', fontSize: '1rem',
              cursor: 'pointer', fontWeight: 'bold'
            }}
          >
            Herladen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
